<template>
  <vs-popup 
    button-close-hidden
    :active.sync="open" 
    title="Delete patient file" 
    @close="closeDialog"
  >
    <div class="p-6 relative">
      <div class="mb-8">
        <h3 class="text-2xl font-bold text-gray-800 mb-5 leading-tight">Delete patient file</h3>
        
        <p class="text-base text-gray-600 mb-6 leading-relaxed font-normal">
          Once this file has been deleted, this action cannot be undone.
        </p>
        
        <div class="bg-gray-50 rounded-lg border border-gray-200 mb-2">
          <p class="font-bold text-gray-800 mb-2 text-base leading-relaxed">{{ fileName }}</p>
          <p class="text-gray-500 text-sm font-normal">{{ fileDate }}</p>
        </div>
      </div>
      
      <div class="flex justify-end space-x-3 mt-6">
        <vs-button
          type="border"
          class="font-semibold text-primary border-gray-600 p-3"
          @click="closeDialog"
        >
          Cancel
        </vs-button>
        <vs-button
          color="danger"
          class="font-semibold p-3"
          @click="confirmDelete"
        >
          Delete
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PatientFileDeleteDialog',
  props: {
    fileName: {
      type: String,
      default: '',
    },
    fileDate: {
      type: String,
      default: '',
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm-delete'],
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    confirmDelete() {
      this.$emit('confirm-delete');
    },
  },
};
</script> 